module.exports = __webpack_public_path__ + "static/media/logo_spine_sfx.866890de.ogg";